import { render, staticRenderFns } from "./SkuInfoInsert.vue?vue&type=template&id=11210b7c&scoped=true&"
import script from "./SkuInfoInsert.vue?vue&type=script&lang=js&"
export * from "./SkuInfoInsert.vue?vue&type=script&lang=js&"
import style0 from "./SkuInfoInsert.vue?vue&type=style&index=0&id=11210b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11210b7c",
  null
  
)

export default component.exports